import { type AvatarSize } from './types.js';

/**
 * Avatar sizes as defined in Contra Design Team Library in Figma.
 * If you don't see the avatar size you need in this list,
 * add it as a number (ie <Avatar size={420} />)
 * @see https://www.figma.com/file/L8Te5meCiyl4s3qkbYLpYN/Contra-Design-Team-Library?node-id=700%3A911
 */
export const AVATAR_SIZES: { [key in Exclude<AvatarSize, number>]: number } = {
  huge: 176,
  lg: 64,
  md: 56,
  sm: 48,
  xl: 96,
  xs: 32,
  xxl: 136,
  xxs: 24,
};
